<template>
    <div>
        <breadcrumbs />
        <div class="mt-4" />
        <communications
            is-calendar-mode
            :communications="communications"
            :communications-loading="communicationsLoading"
            @get-communications="getCommunications"
            @add-communication-filters="addCommunicationFilters"
        />
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/Breadcrumbs.vue'
    import Communications from '@/components/account/communications/Communications.vue'
    import {blankCommunicationFilters} from '@/utils/communications-blank-states'
    import {clean, clone} from '~/utils/helpers'

    @Component({
        components: {
            Communications,
            Breadcrumbs,
        },
    })
    export class CommunicationsCalendarPage extends Vue {
        communicationsLoading = false
        communications = []
        communicationsCount = 0
        communicationFilters = blankCommunicationFilters()

        async getCommunications() {
            try {
                this.communicationsLoading = true
                this.communications = []
                const filters = clone(this.communicationFilters)
                clean(filters)
                if (filters.communicationDateFrom)
                    filters.communicationDateFrom = this.$dateFns.format(filters.communicationDateFrom) + 'T00:00'
                if (filters.createdDateFrom)
                    filters.createdDateFrom = this.$dateFns.format(filters.createdDateFrom) + 'T00:00'
                if (filters.modifiedDateFrom)
                    filters.modifiedDateFrom = this.$dateFns.format(filters.modifiedDateFrom) + 'T00:00'
                if (filters.communicationDateTo)
                    filters.communicationDateTo = this.$dateFns.format(filters.communicationDateTo) + 'T23:59'
                if (filters.createdDateTo)
                    filters.createdDateTo = this.$dateFns.format(filters.createdDateTo) + 'T23:59'
                if (filters.modifiedDateTo)
                    filters.modifiedDateTo = this.$dateFns.format(filters.modifiedDateTo) + 'T23:59'
                const {communications, count} = await this.$api.communications.get({
                    ...filters,
                    typeNEQ: filters.typeNEQ || 'NOTES',
                    assignedToId: this.assignedToId,
                })
                this.communications = communications
                this.communicationsCount = count
                this.communicationsLoading = false
            } catch (e) {
                this.communicationsCount = 0
                this.communications = []
            } finally {
                this.communicationsLoading = false
            }
        }

        addCommunicationFilters(newFilters) {
            this.communicationFilters = {
                ...this.communicationFilters,
                ...newFilters,
            }
        }

        get assignedToId() {
            return authStore.person.personId
        }
    }

    export default CommunicationsCalendarPage
</script>
